import classNames from 'classnames';
import React from 'react';

import Icon from 'components/ui/Icon';

type BadgeWrapperProps = {
  testId?: string;
  className?: string;
  iconName?: string;
  children: React.ReactNode;
  badgeLabel?: React.ReactNode;
};

const BadgeWrapper: React.FC<BadgeWrapperProps> = ({ badgeLabel, iconName, children, testId, className }) => {
  const labelAndIcon = Boolean(badgeLabel && iconName);

  return (
    <div data-testid={testId} className={classNames('relative flex flex-col flex-1', className)}>
      {(badgeLabel || iconName) && (
        <div
          data-testid="method-badge"
          className={classNames(
            'absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 rounded-button flex',
            {
              'px-s py-3xs bg-brand-high text-white whitespace-nowrap font-semibold': badgeLabel,
              '!pl-2': labelAndIcon,
            },
          )}
        >
          {iconName &&
             <div className="z-10 size-16 bg-white rounded-button flex items-center justify-center">
               <Icon className={classNames(iconName, 'text-4xl text-btn-secondary-text')} />
             </div>}
          {badgeLabel &&
            <div data-testid="badge-label" className={classNames('text-xs', { ['ml-2 m-auto']:labelAndIcon })}>
              {badgeLabel}
            </div>}
        </div>
      )}
      {children}
    </div>
  );
};

export default BadgeWrapper;
